(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compose-bed-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }
    function slug(n) { return String(n).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

    // Turns the product JSON from Liquid into something easy to work with.
    // ci = index of the colour option (-1 if none); other = indexes of the remaining options (size etc).
    function prep(p, secName) {
      if (!p || !p.variants || !p.variants.length) return null;
      var names = p.options.map(function (n) { return String(n).trim(); });
      // si = index of the second colour option (for example "Piping colour"), if the item has one.
      var si = -1;
      if (secName) names.forEach(function (n, i) { if (si < 0 && slug(n) === slug(secName)) si = i; });
      var ci = -1;
      names.forEach(function (n, i) { if (ci < 0 && i !== si && /colou?r/i.test(n)) ci = i; });
      var other = [];
      names.forEach(function (n, i) { if (i !== ci && i !== si) other.push(i); });
      var values = other.map(function (i) {
        var seen = [];
        p.variants.forEach(function (v) { if (seen.indexOf(v.options[i]) < 0) seen.push(v.options[i]); });
        return seen;
      });
      var start = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var colours = [];
      if (ci >= 0) p.variants.forEach(function (v) { if (colours.indexOf(v.options[ci]) < 0) colours.push(v.options[ci]); });
      return { title: p.title, style: p.style || p.title, names: names, ci: ci, si: si, other: other, values: values, colours: colours, variants: p.variants, start: start };
    }

    function init(root) {
      if (root.getAttribute('data-compose-ready')) return;
      root.setAttribute('data-compose-ready', '1');

      var cfg = root.dataset;
      // Match the page: find the first real background colour above this section and use it for the sticky image area and the swatch rings.
      (function () {
        function solid(c) { return c && c !== 'transparent' && !/rgba\(\s*\d+,\s*\d+,\s*\d+,\s*0\s*\)/.test(c); }
        var n = root.parentElement;
        while (n) {
          var bg = window.getComputedStyle(n).backgroundColor;
          if (solid(bg)) { root.style.setProperty('--compose-page-bg', bg); return; }
          n = n.parentElement;
        }
      })();
      // The items in this set (1 to 3), from the section settings. The first is the main item, always ordered once.
      var PARTS = [];
      try { PARTS = JSON.parse(root.querySelector('[data-compose-parts]').textContent); } catch (e) { PARTS = []; }
      PARTS.forEach(function (p, i) {
        p.main = i === 0; p.file = slug(p.file || p.id); p.name = String(p.label || p.id).toLowerCase();
        if (p.second) { p.second.file = slug(p.second.file || 'piping'); p.second.label = String(p.second.label || 'Piping'); }
      });
      if (!PARTS.length) return;
      // Add-ons are extra shoppable items with no colour and no preview layer (for example a pillow insert).
      var LAYERED = PARTS.filter(function (p) { return !p.addon; });
      // Each button above the palette: one per item, plus one for an item's second colour (such as piping).
      var TARGETS = [];
      LAYERED.forEach(function (p) {
        TARGETS.push({ key: p.id, part: p, second: false, label: p.label });
        if (p.second) TARGETS.push({ key: p.id + ':2', part: p, second: true, label: p.second.label });
      });
      var imgMap = {};
      String(cfg.swatchFiles || '').split(/[\n;]/).forEach(function (line) {
        var i = line.indexOf('=');
        if (i > 0) { var k = slug(line.slice(0, i)), v = line.slice(i + 1).trim(); if (k && v) imgMap[k] = v; }
      });
      var colourSource = cfg.palette === 'fine' ? '[data-compose-colours-fine]' : '[data-compose-colours]';
      var colours = JSON.parse(root.querySelector(colourSource).textContent).map(function (c) {
        return { id: slug(c.name), name: c.name.toLowerCase(), hex: c.hex, bespoke: c.type === 'bespoke', limited: !!c.limited, image: imgMap[slug(c.name)] || c.image || '' };
      });
      // Optional per-section colour lists: "only" keeps just those colours, "hide" removes those colours.
      function nameSet(str) {
        var out = {}, any = false;
        String(str || '').split(/[,;\n]/).forEach(function (n) { var k = slug(n); if (k) { out[k] = 1; any = true; } });
        return any ? out : null;
      }
      var onlySet = nameSet(cfg.only), hideSet = nameSet(cfg.hide);
      colours = colours.filter(function (c) { return (!onlySet || onlySet[c.id]) && !(hideSet && hideSet[c.id]); });
      if (!colours.length) { if (window.console) console.warn('Compose: the colour lists leave no colours to offer.'); return; }
      var hasBespoke = colours.some(function (c) { return c.bespoke; });
      var hasMain = colours.some(function (c) { return !c.bespoke; });
      var byId = {};
      colours.forEach(function (c) { byId[c.id] = c; });
      var firstMain = (colours.filter(function (c) { return !c.bespoke; })[0] || colours[0]).id;

      var dir = cfg.dir || (cfg.probe ? cfg.probe.slice(0, cfg.probe.lastIndexOf('/') + 1) : '');
      if (dir && dir.charAt(dir.length - 1) !== '/') dir += '/';
      var prefix = cfg.prefix || 'compose';
      var note = cfg.note || '';

      // Swatch images are files in Shopify Files (served from /cdn/shop/files/). The hex colour shows underneath if one is missing.
      var useImages = cfg.swatchImages !== 'false';
      function paint(node, c) {
        node.style.setProperty('--c', c.hex);
        node.style.backgroundImage = (useImages && c.image) ? 'url("/cdn/shop/files/' + encodeURIComponent(c.image) + '?width=120")' : '';
      }

      var shopOn = cfg.shop === 'true';
      var fallbackSlug = cfg.fallback ? slug(cfg.fallback) : '';
      var cur = cfg.currency || 'EUR';
      var locale = cfg.locale || document.documentElement.lang || undefined;
      var raw = {};
      try { raw = JSON.parse(root.querySelector('[data-compose-products]').textContent) || {}; } catch (e) { raw = {}; }
      var prods = {};
      Object.keys(raw).forEach(function (k) {
        var owner = PARTS.filter(function (q) { return q.id === k.replace(/_[bc]$/, ''); })[0];
        prods[k] = prep(raw[k], owner && owner.second ? owner.second.option : '');
      });
      // Each item can offer up to three products as "styles" (for example with sewing, with piping).
      PARTS.forEach(function (p) {
        p.styles = ['', '_b', '_c'].map(function (sfx) { return { key: p.id + sfx, label: prods[p.id + sfx] ? prods[p.id + sfx].style : '' }; })
          .filter(function (x) { return prods[x.key]; });
      });
      function partProduct(p) { var st = p.styles[state.style[p.id] || 0]; return st ? prods[st.key] : null; }
      function money(cents) {
        var d = cents / 100;
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: cur, minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(d);
        } catch (e) { return d.toFixed(2) + ' ' + cur; }
      }
      function intOr(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : Math.max(0, Math.min(20, n)); }

      var state = { sel: {}, active: PARTS[0].id, open: !hasMain && hasBespoke, pick: {}, qty: {}, busy: false, style: {}, acol: {}, sel2: {}, active2: false };
      PARTS.forEach(function (p) {
        state.qty[p.id] = p.main ? 1 : intOr(p.qty, 0);
        state.style[p.id] = 0;
        state.sel[p.id] = firstMain;
        if (p.second) {
          p.second.onlySet = p.second.palette === 'piping' ? nameSet(cfg.piping) : nameSet(p.second.only);
          var firstSecond = colours.filter(function (c) { return !p.second.onlySet || p.second.onlySet[c.id]; })[0];
          state.sel2[p.id] = firstSecond ? firstSecond.id : firstMain;
        } else { state.sel2[p.id] = firstMain; }
        var prod = partProduct(p);
        state.pick[p.id] = prod ? prod.other.map(function (i) { return prod.start.options[i]; }) : [];
        // Add-ons have no palette: their colour is chosen from a drop-down of the product's own colour values.
        if (p.addon && prod && prod.ci >= 0) state.acol[p.id] = prod.start.options[prod.ci];
      });

      // Finds the variant for the chosen size(s) and colour. A colour that is not a variant of the product
      // falls back to the fallback colour (or the first one); the real colour still travels as a property.
      function resolve(p) {
        var prod = partProduct(p);
        if (!prod) return { variant: null, exact: false };
        var pick = state.pick[p.id];
        function find(colSlug, secSlug) {
          return prod.variants.filter(function (v) {
            for (var k = 0; k < prod.other.length; k++) { if (v.options[prod.other[k]] !== pick[k]) return false; }
            if (prod.ci >= 0 && colSlug) { if (slug(v.options[prod.ci]) !== colSlug) return false; }
            if (prod.si >= 0 && secSlug) { if (slug(v.options[prod.si]) !== secSlug) return false; }
            return true;
          })[0] || null;
        }
        if (p.addon) {
          if (prod.ci < 0) return { variant: find(''), exact: true };
          return { variant: find(slug(state.acol[p.id])), exact: true };
        }
        // A colour that is not a variant of the product falls back to the fallback colour (or any), and the real colour still travels as a property.
        var mains = prod.ci < 0 ? [''] : [byId[state.sel[p.id]].id, fallbackSlug, ''];
        var secs = prod.si < 0 ? [''] : [byId[state.sel2[p.id]].id, fallbackSlug, ''];
        for (var i = 0; i < mains.length; i++) {
          for (var j = 0; j < secs.length; j++) {
            var hit = find(mains[i], secs[j]);
            if (hit) return { variant: hit, exact: i === 0 && j === 0 };
          }
        }
        return { variant: null, exact: false };
      }
      // Switching style keeps the chosen size when the new product has the same option and value.
      function setStyle(p, i) {
        var old = partProduct(p), oldPick = state.pick[p.id];
        state.style[p.id] = i;
        var prod = partProduct(p);
        state.pick[p.id] = prod.other.map(function (idx, k) {
          var oi = old ? old.names.indexOf(prod.names[idx]) : -1;
          var ok = oi >= 0 ? old.other.indexOf(oi) : -1;
          var want = ok >= 0 ? oldPick[ok] : null;
          return (want && prod.values[k].indexOf(want) >= 0) ? want : prod.start.options[idx];
        });
      }
      function styleProp(p) {
        if (p.styles.length < 2) return null;
        return { key: propName(p) + ' style', value: p.styles[state.style[p.id] || 0].label };
      }
      function activeParts() { return PARTS.filter(function (p) { return p.main || state.qty[p.id] > 0; }); }

      var layersHost = root.querySelector('[data-compose-layers]');
      var controls = root.querySelector('[data-compose-controls]');
      var refs = { layers: {}, layers2: {}, items: {}, buttons: {} };

      function layerUrl(p, colour) { return dir + prefix + '-' + p.file + '-' + colour.id + '.png'; }
      function layerUrl2(p, colour) { return dir + prefix + '-' + p.file + '-' + p.second.file + '-' + colour.id + '.png'; }
      function propName(p) { return p.prop || p.label; }
      function secondProp(p) { return propName(p) + ' ' + p.second.label.toLowerCase(); }
      function activePart() { return PARTS.filter(function (p) { return p.id === state.active; })[0]; }
      function selMap() { return state.active2 ? state.sel2 : state.sel; }

      function build() {
        // One layer image per item.
        LAYERED.forEach(function (p) {
          var img = el('img', 'compose-layer');
          img.alt = '';
          img.addEventListener('load', function () { img.classList.add('is-loaded'); });
          img.addEventListener('error', function () {
            img.classList.remove('is-loaded');
            if (window.console) console.warn('Compose: layer image not found', img.src);
          });
          img.style.zIndex = String(parseInt(p.z, 10) || 1);
          refs.layers[p.id] = img;
          layersHost.appendChild(img);
          if (p.second) {
            // The second colour (piping) is its own transparent layer, drawn straight above the item.
            var img2 = el('img', 'compose-layer');
            img2.alt = '';
            img2.addEventListener('load', function () { img2.classList.add('is-loaded'); });
            img2.addEventListener('error', function () {
              img2.classList.remove('is-loaded');
              if (window.console) console.warn('Compose: layer image not found', img2.src);
            });
            img2.style.zIndex = String(parseInt(p.z, 10) || 1);
            refs.layers2[p.id] = img2;
            layersHost.appendChild(img2);
          }
        });

        // Step 1: choose the item.
        var items = el('div', 'compose-items');
        items.setAttribute('role', 'group');
        items.setAttribute('aria-label', 'Choose an item to colour');
        items.style.gridTemplateColumns = 'repeat(auto-fit, minmax(104px, 1fr))';
        TARGETS.forEach(function (t) {
          var p = t.part;
          var b = el('button', 'compose-item');
          b.type = 'button';
          b.setAttribute('aria-pressed', 'false');
          var colour = el('span', 'compose-item-colour');
          var dot = el('i', 'compose-dot');
          var cname = el('span');
          colour.appendChild(dot);
          colour.appendChild(cname);
          b.appendChild(el('span', 'compose-item-name', t.label));
          b.appendChild(colour);
          b.addEventListener('click', function () {
            state.active = p.id;
            state.active2 = t.second;
            state.open = byId[(t.second ? state.sel2 : state.sel)[p.id]].bespoke;
            update();
          });
          refs.items[t.key] = { btn: b, dot: dot, cname: cname };
          items.appendChild(b);
        });
        controls.appendChild(items);

        // Step 2: one palette for the chosen item.
        var palette = el('div', 'compose-palette');
        refs.prompt = el('p', 'compose-prompt');
        refs.prompt.setAttribute('aria-live', 'polite');

        var mainGrid = el('div', 'compose-grid');
        mainGrid.setAttribute('role', 'group');
        mainGrid.setAttribute('aria-label', cfg.mainLabel || 'Main colours');
        var bGrid = el('div', 'compose-grid is-six');
        bGrid.setAttribute('role', 'group');
        bGrid.setAttribute('aria-label', 'Bespoke colours');
        colours.forEach(function (c) {
          var b = el('button', 'compose-sq' + (c.bespoke ? ' is-bespoke' : ''));
          b.type = 'button';
          if (c.bespoke) {
            // Bespoke colours: a round swatch inside the square frame.
            var disc = el('i', 'compose-disc');
            paint(disc, c);
            b.appendChild(disc);
          } else {
            paint(b, c);
          }
          b.setAttribute('aria-pressed', 'false');
          b.setAttribute('aria-label', c.name + (c.bespoke ? ', bespoke' : ''));
          // Hover label: just the colour name.
          b.setAttribute('data-hover-label', c.name);
          b.addEventListener('click', function () {
            if (b.getAttribute('aria-disabled') === 'true') return;
            selMap()[state.active] = c.id;
            if (state.qty[state.active] === 0) state.qty[state.active] = 1;
            update();
          });
          refs.buttons[c.id] = b;
          (c.bespoke ? bGrid : mainGrid).appendChild(b);
        });

        refs.reveal = el('button', 'compose-reveal');
        refs.reveal.type = 'button';
        refs.reveal.addEventListener('click', function () { state.open = !state.open; update(); });

        refs.panel = el('div', 'compose-bespoke');
        refs.panel.appendChild(el('p', 'compose-head', 'Bespoke colour collection'));
        if (note) refs.panel.appendChild(el('p', 'compose-note', note));
        refs.panel.appendChild(bGrid);

        palette.appendChild(refs.prompt);
        if (hasMain) {
          palette.appendChild(el('p', 'compose-bar', cfg.mainLabel || 'Main colour collection'));
          palette.appendChild(mainGrid);
        }
        if (hasBespoke) {
          palette.appendChild(refs.reveal);
          palette.appendChild(refs.panel);
        }
        controls.appendChild(palette);
        if (shopOn) buildShop();
      }

      function buildShop() {
        var box = el('div', 'compose-shop');
        box.appendChild(el('p', 'compose-bar', 'Create your set'));
        refs.lines = {};
        PARTS.forEach(function (p) {
          var prod = partProduct(p);
          var line = el('div', 'compose-line');
          var head = el('div', 'compose-line-head');
          var nameEl = el('span', 'compose-line-name', p.label);
          // Add-ons are not drawn on the picture, so say so beside the name.
          if (p.addon) nameEl.appendChild(el('em', 'compose-line-note', 'item not shown on image'));
          head.appendChild(nameEl);
          var price = el('span', 'compose-line-price');
          head.appendChild(price);
          line.appendChild(head);
          var row = el('div', 'compose-line-row');
          var fields = el('div', 'compose-fields');
          row.appendChild(fields);
          function fill() {
            fields.textContent = '';
            var cur_ = partProduct(p);
            if (!cur_) {
              fields.appendChild(el('p', 'compose-note', 'Choose the product for ' + p.name + ' in the section settings.'));
              return;
            }
            if (p.styles.length > 1) {
              var swrap = el('label', 'compose-field');
              swrap.appendChild(el('span', 'compose-field-label', cfg.styleLabel || 'Style'));
              var ssel = el('select', 'compose-select');
              p.styles.forEach(function (st, si) { var o = el('option', null, st.label); o.value = String(si); ssel.appendChild(o); });
              ssel.value = String(state.style[p.id] || 0);
              ssel.addEventListener('change', function () { setStyle(p, parseInt(ssel.value, 10)); fill(); update(); });
              swrap.appendChild(ssel);
              fields.appendChild(swrap);
            }
            if (p.addon && cur_.ci >= 0 && cur_.colours.length) {
              var cwrap = el('label', 'compose-field');
              cwrap.appendChild(el('span', 'compose-field-label', cur_.names[cur_.ci]));
              var csel = el('select', 'compose-select');
              cur_.colours.forEach(function (val) { var o = el('option', null, val); o.value = val; csel.appendChild(o); });
              csel.value = state.acol[p.id];
              csel.addEventListener('change', function () { state.acol[p.id] = csel.value; update(); });
              cwrap.appendChild(csel);
              fields.appendChild(cwrap);
            }
            cur_.other.forEach(function (idx, k) {
              var wrap = el('label', 'compose-field');
              wrap.appendChild(el('span', 'compose-field-label', cur_.names[idx]));
              var sel = el('select', 'compose-select');
              cur_.values[k].forEach(function (val) { var o = el('option', null, val); o.value = val; sel.appendChild(o); });
              sel.value = state.pick[p.id][k];
              sel.addEventListener('change', function () { state.pick[p.id][k] = sel.value; update(); });
              wrap.appendChild(sel);
              fields.appendChild(wrap);
            });
          }
          fill();
          var num = null, minus = null, plus = null;
          if (!p.main && prod) {
            var qty = el('div', 'compose-qty');
            minus = el('button', null, '\u2212');
            minus.type = 'button';
            minus.setAttribute('aria-label', 'Fewer ' + p.name);
            num = el('span', 'compose-qty-num');
            num.setAttribute('aria-live', 'polite');
            plus = el('button', null, '+');
            plus.type = 'button';
            plus.setAttribute('aria-label', 'More ' + p.name);
            minus.addEventListener('click', function () { state.qty[p.id] = Math.max(0, state.qty[p.id] - 1); update(); });
            plus.addEventListener('click', function () { state.qty[p.id] = Math.min(20, state.qty[p.id] + 1); update(); });
            qty.appendChild(minus);
            qty.appendChild(num);
            qty.appendChild(plus);
            row.appendChild(qty);
          }
          line.appendChild(row);
          refs.lines[p.id] = { line: line, price: price, num: num, minus: minus, plus: plus };
          box.appendChild(line);
        });

        var total = el('div', 'compose-total');
        total.appendChild(el('span', null, 'Total'));
        refs.total = el('strong');
        total.appendChild(refs.total);
        box.appendChild(total);

        refs.fee = el('p', 'compose-fee');
        box.appendChild(refs.fee);

        refs.add = el('button', 'compose-add', cfg.addLabel || 'Add set to cart');
        refs.add.type = 'button';
        refs.add.addEventListener('click', addSet);
        box.appendChild(refs.add);

        refs.msg = el('p', 'compose-msg');
        refs.msg.setAttribute('role', 'status');
        refs.msg.setAttribute('aria-live', 'polite');
        box.appendChild(refs.msg);

        controls.appendChild(box);
      }

      function say(text, isError) {
        if (!refs.msg) return;
        refs.msg.textContent = text || '';
        refs.msg.classList.toggle('is-error', !!isError);
      }

      var warned = {};
      function updateShop() {
        var total = 0, ok = true;
        PARTS.forEach(function (p) {
          var ln = refs.lines[p.id];
          var q = state.qty[p.id];
          var prod = partProduct(p);
          ln.line.classList.toggle('is-off', q === 0);
          if (ln.num) {
            ln.num.textContent = String(q);
            ln.minus.disabled = q <= 0;
            ln.plus.disabled = q >= 20;
          }
          if (!prod) { ln.price.textContent = ''; if (q > 0) ok = false; return; }
          if (q === 0) { ln.price.textContent = p.addon ? '' : 'not shown'; return; }
          var r = resolve(p);
          if (!r.variant) { ln.price.textContent = 'not available'; ok = false; return; }
          if (!r.exact && window.console && !warned[prod.title + byId[state.sel[p.id]].id]) console.warn('Compose: ' + byId[state.sel[p.id]].name + ' is not a variant of ' + prod.title + '; using ' + r.variant.options.join(' / ') + ' and recording the colour as a property.');
          if (!r.exact) warned[prod.title + byId[state.sel[p.id]].id] = 1;
          total += r.variant.price * q;
          ln.price.textContent = (q > 1 ? q + ' \u00d7 ' : '') + money(r.variant.price) + (r.variant.available ? '' : ' \u00b7 sold out');
          if (!r.variant.available) ok = false;
        });
        refs.total.textContent = money(total);
        var names = bespokeNames();
        refs.fee.textContent = names.length
          ? names.length + ' bespoke colour' + (names.length > 1 ? 's' : '') + ' (' + names.join(', ') + '): the dyeing fee is added at checkout.'
          : '';
        refs.add.disabled = !ok || state.busy;
      }

      function addSet() {
        if (state.busy) return;
        var setId = 'cs-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        var props = {};
        propertyValues().forEach(function (v) { props[v.key] = v.value; });
        props._compose_set = setId;
        var items = [];
        var bad = false;
        activeParts().forEach(function (p) {
          var r = resolve(p);
          if (!r.variant || !r.variant.available) { bad = true; return; }
          var own = {};
          // Every item is its own cart line carrying only its own choices (colour and style), plus the hidden set details.
          var c = byId[state.sel[p.id]];
          // Every item carries its own colour, even where it is also the variant. Add-ons have no colour.
          if (!p.addon) own[propName(p)] = c.name + (c.bespoke ? ' (bespoke)' : '');
          if (p.second) { var c2 = byId[state.sel2[p.id]]; own[secondProp(p)] = c2.name + (c2.bespoke ? ' (bespoke)' : ''); }
          var sp = styleProp(p);
          if (sp) own[sp.key] = sp.value;
          ['_compose_set', '_bespoke_count', '_bespoke_colours'].forEach(function (k) { if (props[k] != null) own[k] = props[k]; });
          items.push({ id: r.variant.id, quantity: state.qty[p.id], properties: own });
        });
        if (bad || !items.length) { say('One of the chosen items is not available.', true); return; }

        state.busy = true;
        refs.add.disabled = true;
        say('Adding to your cart\u2026');
        var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root_ + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        }).then(function (out) {
          state.busy = false;
          if (!out.ok) {
            say((out.data && (out.data.description || out.data.message)) || 'Sorry, that could not be added. Please try again.', true);
            updateShop();
            return;
          }
          if (cfg.after === 'stay') {
            say('Added to your cart.');
            ['cart:refresh', 'cart:updated'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
            updateShop();
          } else {
            window.location.href = root_ + 'cart';
          }
        }).catch(function () {
          state.busy = false;
          say('Sorry, something went wrong. Please try again.', true);
          updateShop();
        });
      }

      function bespokeNames() {
        var seen = {}, out = [];
        activeParts().forEach(function (p) {
          if (p.addon) return;
          var c = byId[state.sel[p.id]];
          if (c.bespoke && !seen[c.id]) { seen[c.id] = true; out.push(c.name); }
          if (p.second) { var c2 = byId[state.sel2[p.id]]; if (c2.bespoke && !seen[c2.id]) { seen[c2.id] = true; out.push(c2.name); } }
        });
        return out;
      }

      function propertyValues() {
        var out = [];
        activeParts().forEach(function (p) {
          if (p.addon) return;
          var c = byId[state.sel[p.id]];
          out.push({ key: propName(p), value: c.name + (c.bespoke ? ' (bespoke)' : '') });
          if (p.second) { var c2 = byId[state.sel2[p.id]]; out.push({ key: secondProp(p), value: c2.name + (c2.bespoke ? ' (bespoke)' : '') }); }
          var sp = styleProp(p);
          if (sp) out.push(sp);
        });
        if (cfg.addMeta === 'true') {
          var names = bespokeNames();
          out.push({ key: '_bespoke_count', value: String(names.length) });
          out.push({ key: '_bespoke_colours', value: names.join(', ') });
        }
        return out;
      }

      function syncForms() {
        if (shopOn) return;
        var forms;
        try { forms = document.querySelectorAll(cfg.formSelector || 'form[action*="/cart/add"]'); } catch (e) { return; }
        var values = propertyValues();
        Array.prototype.forEach.call(forms, function (form) {
          values.forEach(function (v) {
            var sel = 'input[data-compose-prop="' + v.key.replace(/"/g, '') + '"]';
            var input = form.querySelector(sel);
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.setAttribute('data-compose-prop', v.key);
              input.name = 'properties[' + v.key + ']';
              form.appendChild(input);
            }
            input.value = v.value;
          });
        });
      }

      function update() {
        var active = activePart();
        if (state.active2 && !active.second) state.active2 = false;
        var activeColour = byId[selMap()[active.id]];

        TARGETS.forEach(function (t) {
          var p = t.part;
          var c = byId[(t.second ? state.sel2 : state.sel)[p.id]];
          var item = refs.items[t.key];
          item.btn.setAttribute('aria-pressed', String(p.id === state.active && t.second === state.active2));
          paint(item.dot, c);
          item.cname.textContent = state.qty[p.id] === 0 ? c.name + ' (not shown)' : c.name;
          item.btn.classList.toggle('is-off', state.qty[p.id] === 0);

          var url = t.second ? layerUrl2(p, c) : layerUrl(p, c);
          var img = t.second ? refs.layers2[p.id] : refs.layers[p.id];
          img.hidden = state.qty[p.id] === 0;
          if (img.getAttribute('data-src') !== url) {
            img.setAttribute('data-src', url);
            img.src = url;
          }
        });

        refs.prompt.textContent = 'Choose the colour for your ' + (state.active2 ? active.second.label.toLowerCase() : active.name);
        // A "limited" colour (such as B/W Check) is only offered for items whose product really has it as a colour.
        var activeProd = shopOn ? partProduct(active) : null;
        function hasColour(prod, id) {
          var idx = prod ? (state.active2 ? prod.si : prod.ci) : -1;
          if (idx < 0) return true;
          return prod.variants.some(function (v) { return slug(v.options[idx]) === id; });
        }
        // A second colour (such as piping) can be limited to some of the colours.
        var allow = (state.active2 && active.second && active.second.onlySet) ? active.second.onlySet : null;
        var bespokeOk = hasBespoke && (!allow || colours.some(function (c) { return c.bespoke && allow[c.id]; }));
        Object.keys(refs.buttons).forEach(function (id) {
          var btn = refs.buttons[id];
          btn.hidden = !!allow && !allow[id];
          btn.setAttribute('aria-pressed', String(id === activeColour.id));
          if (byId[id].limited) {
            var off = !!activeProd && !hasColour(activeProd, id);
            btn.setAttribute('aria-disabled', String(off));
            btn.classList.toggle('is-unavailable', off);
            btn.setAttribute('data-hover-label', off ? byId[id].name + ' (not available for this item)' : byId[id].name);
          }
        });
        refs.panel.hidden = !state.open || !bespokeOk;
        refs.reveal.hidden = !bespokeOk;
        refs.reveal.setAttribute('aria-expanded', String(!!state.open));
        refs.reveal.textContent = 'View bespoke colour collection ' + (state.open ? '↓' : '→');

        if (shopOn) updateShop(); else syncForms();
      }

      // Write the properties just before the theme reads the form (AJAX or normal submit).
      if (!shopOn) document.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest) {
          try { if (t.closest(cfg.formSelector || 'form[action*="/cart/add"]')) syncForms(); } catch (err) {}
        }
      }, true);
      if (!shopOn) document.addEventListener('submit', syncForms, true);

      build();
      update();
    }

    // Pop-up mode: the button opens Compose in a dialog. The dialog moves to <body> while open so no theme container can clip it.
    function setupPopups(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-compose-popup]'), function (wrap) {
        if (wrap.getAttribute('data-popup-ready')) return;
        wrap.setAttribute('data-popup-ready', '1');
        var trigger = wrap.querySelector('.compose-popup-trigger');
        var opener = trigger;
        var pop = wrap.querySelector('.compose-popup');
        var closeBtn = pop.querySelector('.compose-popup-close');
        function focusables() {
          return Array.prototype.filter.call(pop.querySelectorAll('button, select, input, a[href], [tabindex]'), function (n) {
            return !n.disabled && n.tabIndex >= 0 && n.offsetParent !== null;
          });
        }
        function onKey(e) {
          if (e.key === 'Escape') { e.preventDefault(); close(); return; }
          if (e.key !== 'Tab') return;
          var f = focusables();
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
        function open(from) {
          opener = (from && from.focus) ? from : trigger;
          document.body.appendChild(pop);
          pop.hidden = false;
          document.documentElement.classList.add('compose-popup-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          document.addEventListener('keydown', onKey);
          closeBtn.focus();
        }
        function close() {
          pop.hidden = true;
          wrap.appendChild(pop);
          document.documentElement.classList.remove('compose-popup-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          document.removeEventListener('keydown', onKey);
          if (opener && opener.focus) opener.focus();
        }
        wrap._composeOpen = open;
        if (trigger) trigger.addEventListener('click', function () { open(trigger); });
        pop.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-compose-close]')) close(); });
      });
    }

    // Any button or link elsewhere on the page (for example in the product form) can open a pop-up:
    // give it data-compose-open="the pop-up ID set in the section".
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-compose-open]') : null;
      if (!t) return;
      var key = t.getAttribute('data-compose-open');
      var wraps = document.querySelectorAll('[data-compose-popup]');
      for (var i = 0; i < wraps.length; i++) {
        if (wraps[i].getAttribute('data-popup-key') === key && wraps[i]._composeOpen) {
          e.preventDefault();
          wraps[i]._composeOpen(t);
          return;
        }
      }
    });

    function initAll(scope) {
      setupPopups(scope);
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-compose-bed]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var id = e.target && e.target.id ? e.target.id.replace(/^shopify-section-/, '') : '';
      Array.prototype.forEach.call(document.body.querySelectorAll('.compose-popup[data-popup-id="' + id + '"]'), function (n) { n.parentNode.removeChild(n); });
      document.documentElement.classList.remove('compose-popup-open');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
